import { Search } from 'lucide-react'
import { cn } from '../../lib/cn'
import s from './SearchField.module.css'

/**
 * Champ de recherche — le champ à loupe des barres de titre du prototype.
 *
 * Contrôlé, sans debounce : filtrer une liste déjà en mémoire est instantané. Le jour
 * où la recherche interroge le serveur (D21), le debounce se posera **dans la couche
 * données**, pas ici — le champ reste un simple miroir valeur/événement.
 */
export interface SearchFieldProps {
  value: string
  onValueChange: (value: string) => void
  placeholder?: string
  /** Nom accessible du champ — la loupe n'en fournit aucun. */
  label: string
  /**
   * Le champ n'est pas câblé, ou l'écran ne peut pas chercher pour l'instant.
   *
   * ⚠️ **Posé sur l'`<input>`, et publié au DOM par le cadre** : c'est l'`<input>` que le
   * navigateur retire de la tabulation, et `.root:has(input:disabled)` qui grise la loupe avec.
   * Griser la seule loupe laisserait un champ qui a l'air actif au curseur.
   */
  disabled?: boolean
  className?: string
}

export function SearchField({
  value,
  onValueChange,
  placeholder,
  label,
  disabled,
  className,
}: SearchFieldProps) {
  return (
    <label className={cn(s.root, className)}>
      <Search size={19} aria-hidden />
      <input
        type="search"
        value={value}
        placeholder={placeholder}
        aria-label={label}
        disabled={disabled}
        onChange={(event) => onValueChange(event.target.value)}
      />
    </label>
  )
}
